import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { Customer } from "../../models";
import { RQ } from "../../globals/enums";
import { deleteEntity } from "../../utils";
import { remove } from "../../api/generic-api";

export const useDeleteCustomer = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("customers", id), {
    onSuccess: (_, id) => {
      queryClient.setQueryData(
        RQ.CUSTOMERS,
        (customers: Customer[] | undefined) => {
          enqueueSnackbar("Customer Deleted", { variant: "success" });
          return !customers ? [] : deleteEntity<Customer>(customers, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Customer Deleting Error", { variant: "error" });
    },
  });
};
